import React from 'react';

function getDisplayStatus(invoice) {
  if (!invoice) {
    return 'draft';
  }

  if (invoice.status === 'paid' || invoice.status === 'draft' || invoice.status === 'overdue') {
    return invoice.status;
  }

  if (invoice.due_date && new Date(invoice.due_date) < new Date()) {
    return 'overdue';
  }

  return invoice.status || 'draft';
}

export default function StatusPill({ invoice, status }) {
  const displayStatus = invoice ? getDisplayStatus(invoice) : status || 'draft';

  return (
    <span className={`status-pill status-${displayStatus}`}>
      <span className="status-dot" />
      {displayStatus.replace('_', ' ')}
    </span>
  );
}